import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type StorefrontAbTestId = ID<"storefrontAbTest">;
export const storefrontAbTestIdFormat = idFormat<StorefrontAbTestId>({
  prefix: "sabt_",
});

export type StorefrontTreatmentId = ID<"storefrontTreatment">;
export const storefrontTreatmentIdFormat = idFormat<StorefrontTreatmentId>({
  prefix: "strt_",
});

export type CoverageProductControlId = ID<"coverageProductControl">;
export const coverageProductControlIdFormat =
  idFormat<CoverageProductControlId>({ prefix: "cpc_" });
